import { render, staticRenderFns } from "./Distributor_companies_list.vue?vue&type=template&id=fac8c5b2&scoped=true&lang=pug&"
import script from "./Distributor_companies_list.vue?vue&type=script&lang=coffee&"
export * from "./Distributor_companies_list.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fac8c5b2",
  null
  
)

export default component.exports